if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        const target = event.currentTarget;
        this.elements.input.value = target.dataset.value;

        if (this.elements.input.name === 'country_code') {
          const countryCodeStr = target.dataset.value;
          
          // Country to currency mapping for the most common countries
          const currencyMap = {
            'AE': { c: 'AED', s: 'د.إ' }, 'AR': { c: 'ARS', s: '$' }, 'AU': { c: 'AUD', s: '$' }, 
            'BR': { c: 'BRL', s: 'R$' }, 'CA': { c: 'CAD', s: '$' }, 'CH': { c: 'CHF', s: 'CHF' },
            'CL': { c: 'CLP', s: '$' }, 'CN': { c: 'CNY', s: '¥' }, 'CO': { c: 'COP', s: '$' },
            'DK': { c: 'DKK', s: 'kr.' }, 'GB': { c: 'GBP', s: '£' }, 'HK': { c: 'HKD', s: '$' },
            'ID': { c: 'IDR', s: 'Rp' }, 'IL': { c: 'ILS', s: '₪' }, 'IN': { c: 'INR', s: '₹' },
            'JP': { c: 'JPY', s: '¥' }, 'KR': { c: 'KRW', s: '₩' }, 'MX': { c: 'MXN', s: '$' },
            'MY': { c: 'MYR', s: 'RM' }, 'NZ': { c: 'NZD', s: '$' }, 'PE': { c: 'PEN', s: 'S/' },
            'PH': { c: 'PHP', s: '₱' }, 'PL': { c: 'PLN', s: 'zł' }, 'RU': { c: 'RUB', s: '₽' },
            'SA': { c: 'SAR', s: '﷼' }, 'SE': { c: 'SEK', s: 'kr' }, 'SG': { c: 'SGD', s: '$' },
            'TH': { c: 'THB', s: '฿' }, 'TR': { c: 'TRY', s: '₺' }, 'US': { c: 'USD', s: '$' },
            'VN': { c: 'VND', s: '₫' }, 'ZA': { c: 'ZAR', s: 'R' },
            'AT': { c: 'EUR', s: '€' }, 'BE': { c: 'EUR', s: '€' }, 'CY': { c: 'EUR', s: '€' },
            'EE': { c: 'EUR', s: '€' }, 'FI': { c: 'EUR', s: '€' }, 'FR': { c: 'EUR', s: '€' },
            'DE': { c: 'EUR', s: '€' }, 'GR': { c: 'EUR', s: '€' }, 'IE': { c: 'EUR', s: '€' },
            'IT': { c: 'EUR', s: '€' }, 'LV': { c: 'EUR', s: '€' }, 'LT': { c: 'EUR', s: '€' },
            'LU': { c: 'EUR', s: '€' }, 'MT': { c: 'EUR', s: '€' }, 'NL': { c: 'EUR', s: '€' },
            'PT': { c: 'EUR', s: '€' }, 'SK': { c: 'EUR', s: '€' }, 'SI': { c: 'EUR', s: '€' },
            'ES': { c: 'EUR', s: '€' }
          };

          // Try to map it, otherwise fallback to target dataset or default to BRL
          const mapped = currencyMap[countryCodeStr];
          const currencyCode = mapped ? mapped.c : (target.dataset.currency || 'BRL');
          const currencySymbol = mapped ? mapped.s : (target.dataset.symbol || 'R$');

          const currencyElement = target.querySelector('.localization-form__currency');
          if (currencyElement) {
            this.elements.button.querySelector('span').innerHTML = currencyElement.innerHTML;
          }
          
          this.querySelectorAll('li').forEach(li => li.classList.remove('active'));
          this.querySelectorAll('a').forEach(a => a.removeAttribute('aria-current'));
          
          target.closest('li').classList.add('active');
          target.setAttribute('aria-current', 'true');
          
          if (currencyCode) {
            localStorage.setItem('selected_currency', currencyCode);
            localStorage.setItem('selected_symbol', currencySymbol || '');
            window.dispatchEvent(new CustomEvent('currency:changed', { detail: { currency: currencyCode, symbol: currencySymbol || '' } }));
          }
          
          this.hidePanel();
        } else {
          if (form) form.submit();
        }
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
